<template>
	<tr>
		<td data-th="Product">
			<div class="row">
				<!-- <div class="col-sm-2 d-none d-sm-block">
					<img :src="cartItem.picUrl" alt="..." class="img-fluid"/>
				</div> -->
				<div class="col-sm-12">
					<h6 class="nomargin">{{ cartItem.title }}</h6>
					<!-- <p>{{ cartItem.description }}</p> -->
				</div>
			</div>
		</td>
		<td data-th="Price">
			<div v-if="serviceFlag!=true">
				{{ cartItem.price }}
			</div>
			<div v-else>
				<input type="number" class="form-control text-center"
					:value="cartItem.price"
					@input="updatePrice"
					min="0">
			</div>
		</td>

		
		<td data-th="Discount">
			<input type="number" class="form-control text-center"
				:value="cartItem.discount"
				@input="updateDiscount"
				min="0">
		</td>
		<td data-th="Quantity">
			<input type="number" class="form-control text-center"
				:value="cartItem.quantity"
				@input="updateQuantity"
				min="0">
		</td>
		<td data-th="Subtotal" style="padding-right: 25px;" class="text-right">{{ subtotal }}</td>
		<td class="actions" data-th="">
			<button class="btn btn-danger btn-sm" @click="removeItem"><i class="fa fa-trash-o"></i></button>
		</td>
	</tr>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	export default {
		props: ['cartItem'],
		computed: {
			...mapGetters(['cartItemList', 'serviceFlag']),

			subtotal() {
				let amt = (this.cartItem.price - this.cartItem.discount) * this.cartItem.quantity 
				return amt.toFixed(2)
			}
		},
		methods: {
			...mapActions(['updateCart', 'removeItemInCart', 'clearPayment']),
			removeItem() {
				let vm = this;
				this.removeItemInCart({
					item: vm.cartItem
				});
				// If no item in the cart, clear payment information
				if (this.cartItemList.length == 0){
					this.clearPayment()
				}
			},
			updatePrice(event) {
				let vm = this;
				if (!event.target.value)
					event.target.value = "0"
				this.updateCart({
					item: vm.cartItem,
					price: parseFloat(event.target.value),
					discount: vm.cartItem.discount,
					quantity: vm.cartItem.quantity,
					isAdd: false
				});
			},
			updateQuantity(event) {
				let vm = this;
				if (!event.target.value)
					event.target.value = "0"
				this.updateCart({
					item: vm.cartItem,
					price: vm.cartItem.price,
					discount: vm.cartItem.discount,
					quantity: parseFloat(event.target.value),
					isAdd: false
				});
			},
			updateDiscount(event) {
				let vm = this;
				if (!event.target.value)
					event.target.value = "0"
				this.updateCart({
					item: vm.cartItem,
					price: vm.cartItem.price,
					discount: parseFloat(event.target.value),
					quantity: vm.cartItem.quantity,
					isAdd: false
				});
			}
		}
	}
</script>
